(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-benefits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maison-benefits-carousel')) {
  customElements.define('maison-benefits-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.maison-benefits__grid');
      this.cards = Array.from(this.querySelectorAll('.maison-benefits__card'));
      this.controls = Array.from(this.querySelectorAll('[data-direction]'));
      this.count = this.querySelector('.maison-benefits__count');
      if (!this.track || !this.cards.length) return;
      const update = () => {
        const origin = this.track.getBoundingClientRect().left + parseFloat(getComputedStyle(this.track).paddingLeft);
        let nearest = 0;
        this.cards.forEach((card, index) => {
          if (Math.abs(card.getBoundingClientRect().left - origin) < Math.abs(this.cards[nearest].getBoundingClientRect().left - origin)) nearest = index;
        });
        this.index = nearest;
        this.count.textContent = `${nearest + 1} / ${this.cards.length}`;
        this.controls.forEach(button => { button.disabled = Number(button.dataset.direction) < 0 ? nearest === 0 : nearest === this.cards.length - 1; });
      };
      const moveTo = index => {
        const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
        const left = this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left - parseFloat(getComputedStyle(this.track).paddingLeft);
        this.track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.controls.forEach(button => button.addEventListener('click', () => moveTo((this.index || 0) + Number(button.dataset.direction))));
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(update); }, {passive: true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.indexOf(event.target.closest('.maison-benefits__card'));
        if (index >= 0 && matchMedia('(max-width: 989px)').matches) moveTo(index);
      });
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-client-loop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-client-loop')) {
    customElements.define('maison-client-loop', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('button');
        if (!this.toggle) return;
        this.abort = new AbortController();
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          this.toggle.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { if (this.abort) this.abort.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-room-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maison-room-tabs')) {
  customElements.define('maison-room-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[role="tabpanel"]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) this.select(index);
      });
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-video-hero')) {
    customElements.define('maison-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('button');
        if (!this.video || !this.toggle) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches;
        this.video.muted = true;
        const sync = () => {
          this.toggle.dataset.paused = String(this.video.paused);
          this.toggle.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        };
        const play = () => this.video.play().catch(sync);
        this.video.addEventListener('play', sync, options);
        this.video.addEventListener('pause', sync, options);
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.video.paused) play(); else this.video.pause();
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.userPaused = true; this.video.pause(); }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (!this.inView) this.video.pause();
          else if (!this.userPaused && !document.hidden) play();
        }, { threshold: 0.1 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else if (this.inView && !this.userPaused) play();
        }, options);
        if (this.userPaused) this.video.pause();
        this.toggle.hidden = false;
        sync();
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
